import { BrowserMultiFormatReader, Result } from "@zxing/library";
import React from "react";
import Webcam from "react-webcam";

export const BarcodeScannerComponent = ({
  onUpdate,
  onError,
  width = "100%",
  height = "100%",
  facingMode = "environment",
  delay = 500,
  videoConstraints,
}: {
  onUpdate: (arg0: unknown | null, arg1?: Result) => void;
  onError?: (arg0: string | DOMException) => void;
  width?: number | string;
  height?: number | string;
  facingMode?: "environment" | "user";
  delay?: number;
  videoConstraints?: MediaTrackConstraints;
}): React.ReactElement => {
  const webcamRef = React.useRef<Webcam>(null);

  const capture = React.useCallback(() => {
    const codeReader = new BrowserMultiFormatReader();
    const imageSrc = webcamRef?.current?.getScreenshot();
    if (imageSrc) {
      codeReader
        .decodeFromImage(undefined, imageSrc)
        .then((result) => {
          onUpdate(null, result);
        })
        .catch((err: unknown) => {
          onUpdate(err);
        });
    }
  }, [onUpdate]);

  React.useEffect(() => {
    const interval = setInterval(capture, delay);
    return () => {
      clearInterval(interval);
    };
  }, []);

  return (
    <Webcam
      width={width}
      height={height}
      ref={webcamRef}
      screenshotFormat="image/jpeg"
      videoConstraints={
        videoConstraints || {
          facingMode,
          aspectRatio: 1,
        }
      }
      audio={false}
      onUserMediaError={onError}
    />
  );
};

export default BarcodeScannerComponent;
